export type StepId = "connect" | "deploy" | "fund" | "swap" | "deposit" | "withdraw" | "claim";

export type StepStatus = "locked" | "active" | "in-progress" | "completed";

export interface StepData {
  accountId?: string;
  deployTxHash?: string;
  fundTxHash?: string;
  swapTxHash?: string;
  depositTxHash?: string;
  withdrawTxHash?: string;
  claimTxHash?: string;
  fundedXlm?: number;
  swappedUsdc?: number;
}

export interface AccountBalances {
  xlm: string;
  usdc: string;
  lpSoroswap: string;
  lpAqua: string;
  lastUpdated: Date | null;
  isLoading: boolean;
}

export interface SwapQuote {
  estimatedUsdc: string | null;
  loading: boolean;
}

export interface LogEntry {
  id: string;
  timestamp: Date;
  level: "info" | "success" | "error";
  message: string;
  txHash?: string;
  details?: string;
}

export const STEP_ORDER: StepId[] = ["connect", "deploy", "fund", "swap", "deposit", "withdraw", "claim"];

export const STEP_META: Record<StepId, { number: number; title: string; description: string }> = {
  connect: { number: 1, title: "Connect Wallet", description: "Link your Stellar wallet to begin" },
  deploy: { number: 2, title: "Deploy Smart Account", description: "Create your on-chain account contract" },
  fund: { number: 3, title: "Fund with XLM", description: "Send XLM to your smart account" },
  swap: { number: 4, title: "Swap XLM to USDC", description: "Convert half your XLM via the Hoops router" },
  deposit: { number: 5, title: "Deposit into LP", description: "Provide liquidity to earn yield" },
  withdraw: { number: 6, title: "Withdraw from LP", description: "Redeem LP positions and get tokens back" },
  claim: { number: 7, title: "Claim Rewards", description: "Harvest Aqua pool rewards" },
};
